import { JsonServiceClient } from "@servicestack/client";
import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/from";
import * as CreDtos from "../CRE.dtos";
var jwtDecode = require('jwt-decode');
var moment = require('moment');

export const forumApi = {
    login: (email: string, password: string, rememberMe: boolean) => {
        var client = new JsonServiceClient("");

        var loginRequest = new CreDtos.ForumLogin();
        loginRequest.userName = email;
        loginRequest.password = password;
        loginRequest.rememberMe = rememberMe;
        loginRequest.provider = "credentials";

        const request = client.postToUrl('/authenticate', loginRequest);
        return Observable.from(request);
    },

    resetPasswordUpdate: (email: string, token: string, password: string) => {
        var client = new JsonServiceClient("");

        var promise = new CreDtos.ResetPasswordUpdate();
        promise.email = email;
        promise.token = token;
        promise.password = password;

        const request = client.patch(promise);

        return Observable.from(request);
    },

    resetPassword: (email: string) => {
        var client = new JsonServiceClient("");

        var promise = new CreDtos.ResetPassword();
        promise.email = email;

        const request = client.patch(promise);

        return Observable.from(request);
    },

    validate: () => {
        /*let authUser = null;
        try {
            let user = localStorage.getItem('user');
            if(user){
                authUser = JSON.parse(user);
            } 
        }
        catch (error) 
        {
        }
        return Observable.of(authUser);*/

        var client = new JsonServiceClient("");
        var promise = new CreDtos.GetCurrentForumMember();
        const request = client.get(promise);
        return Observable.from(request);
    },

    saveAuthUser: (userId: string, email: string, token: string) => {
        var authUser = {
            userId: userId,
            email: email,
            token: token
        };
        try {
            localStorage.setItem('user', JSON.stringify(authUser));
        }
        catch (error) {
            // If there is an error assume there is 
            // no available local storage and force login everytime
        }
    },

    logout: (email: string) => {
        localStorage.removeItem('user');

        var client = new JsonServiceClient("");

        var promise = new CreDtos.ForumLogin();
        promise.userName = email;
        promise.provider = "logout";

        const request = client.postToUrl('/authenticate', promise);

        return Observable.from(request);
    },

    getForum: (id: number, summary: boolean) => {
        var client = new JsonServiceClient("");

        var promise = new CreDtos.GetForum();
        promise.id = id;
        promise.summary = summary;

        const request = client.get(promise);

        return Observable.from(request);
    },

    getForums: (email: string) => {
        var client = new JsonServiceClient("");

        var promise = new CreDtos.GetForumList();
        promise.email = email;

        const request = client.get(promise);

        return Observable.from(request);
    },

    getForumUpdate: (id: number, email: string) => {
        var client = new JsonServiceClient("");

        var promise = new CreDtos.GetForumUpdate();
        promise.id = id;
        promise.email = email;

        const request = client.get(promise);

        return Observable.from(request);
    },

    searchBoards: (email: string, term: string) => {
        var client = new JsonServiceClient("");

        var requestData = new CreDtos.GetForumsSearch();
        requestData.term = term;
        requestData.email = email;

        const request = client.get(requestData);

        return Observable.from(request);
    },

    searchPosts: (id: number, term: string) => {
        var client = new JsonServiceClient("");

        var requestData = new CreDtos.GetForumPostSearch();
        requestData.id = id;
        requestData.term = term;

        const request = client.get(requestData);

        return Observable.from(request);
    },

    searchResources: (id: number, term: string) => {
        var client = new JsonServiceClient("");

        var requestData = new CreDtos.GetForumResourceSearch();
        requestData.id = id;
        requestData.term = term;

        const request = client.get(requestData);

        return Observable.from(request);
    },

    searchMembers: (id: number, term: string) => {
        var client = new JsonServiceClient("");

        var requestData = new CreDtos.GetForumMemberSearch();
        requestData.id = id;
        requestData.term = term;

        const request = client.get(requestData);

        return Observable.from(request);
    },

    savePostReaction: (id: number, forumMemberId: number, forumPostId: number) => {
        var client = new JsonServiceClient("");
        var postReaction = new CreDtos.ForumPostReaction();
        postReaction.forumMemberId = forumMemberId;
        postReaction.forumPostId = forumPostId;

        var promise = new CreDtos.UpdateForumPostReaction();
        promise.id = id;
        promise.forumMemberId = forumMemberId;
        promise.forumPostId = forumPostId;
        promise.postReaction = postReaction;
        const request = client.patch(promise);

        return Observable.from(request);
    },

    saveTag: (id: number, tag: CreDtos.ForumTag) => {
        var client = new JsonServiceClient("");
        
        if (tag.id) {
            var tagRequest = new CreDtos.UpdateForumTag();
            tagRequest.id = id;
            tagRequest.tag = tag;

            const request = client.put(tagRequest);

            return Observable.from(request);
        } else {
            tag.forumId = id;
            var tagRequest = new CreDtos.CreateForumTag();
            tagRequest.id = id;
            tagRequest.tag = tag;

            const request = client.post(tagRequest);

            return Observable.from(request);
        }

    },

    saveForum: (forum) => {
        var client = new JsonServiceClient("");

        var promise = undefined;
        if (forum.id) {
            promise = new CreDtos.UpdateForum();
            promise.forum = forum;

            const request = client.put(promise);

            return Observable.from(request);
        } else {
            promise = new CreDtos.CreateForum();
            promise.forum = forum;

            const request = client.post(promise);

            return Observable.from(request);
        }

    },

    subscribe: (id: number) => {
        var client = new JsonServiceClient("");

        var promise = new CreDtos.SubscribeForum();
        promise.id = id;

        const request = client.put(promise);

        return Observable.from(request);
    },

    flagResource: (id: number, resourceId: number) => {
        var client = new JsonServiceClient("");

        var promise = new CreDtos.FlagForumResource();
        promise.id = id;
        promise.resourceId = resourceId;

        const request = client.patch(promise);

        return Observable.from(request);

    },

    saveResource: (id: number, resource: CreDtos.ForumResource) => {
        var client = new JsonServiceClient("");
        
        if (resource.id) {
            var promise = new CreDtos.UpdateForumResource();
            promise.id = id;
            promise.resource = resource;

            const request = client.put(promise);

            return Observable.from(request);
        } else {
            resource.forumId = id;

            var promise = new CreDtos.CreateForumResource();
            promise.id = id;
            promise.resource = resource;

            const request = client.post(promise);

            return Observable.from(request);
        }

    },

    getMember: (id: number) => {
        var client = new JsonServiceClient("");

        var promise = new CreDtos.GetForumMember();
        promise.id = id;

        const request = client.get(promise);
        return Observable.from(request);
    },

    saveMember: (id: number, member: CreDtos.ForumMemberWithAvatar) => {
        var client = new JsonServiceClient("");

        if (member.id) {
            var promise = new CreDtos.UpdateForumMember();
            //promise.id = id;
            promise.member = member;

            const request = client.put(promise);
            return Observable.from(request);
        } else {
            member.forumId = id;
            var promise = new CreDtos.CreateForumMember();
            //promise.id = id;
            promise.member = member;

            const request = client.post(promise);
            return Observable.from(request);
        }



    },

    saveMemberPassword: (id, member: CreDtos.ForumMemberWithPassword) => {
        var client = new JsonServiceClient("");
        
        if (member.id) {

            var promise = new CreDtos.UpdateForumMemberPassword();
            //promise.id = id;
            promise.member = member;

            const request = client.put(promise);
            return Observable.from(request);
        }
    },

    loadPost: (id: number, forumPostId: number) => {
        var client = new JsonServiceClient("");

        var promise = new CreDtos.GetForumPost();
        promise.id = id;
        promise.forumPostId = forumPostId;

        const request = client.get(promise);
        return Observable.from(request);
    },

    savePost: (id: number, item: CreDtos.ForumPost, tags: CreDtos.ForumMember[]) => {
        var client = new JsonServiceClient("");

        item.forumId = id;

        var promise = new CreDtos.UpdateForumPost();
        promise.id = id;
        promise.post = item;
        promise.taggedMembers = tags;

        if (item.id) {
            const request = client.put(promise);
            return Observable.from(request);
        } else {
            const request = client.post(promise);
            return Observable.from(request);
        }
    },

    savePostTag: (tagId: number, postId: number) => {
        var client = new JsonServiceClient("");
        
        if (tagId && postId) {
            var promise = new CreDtos.AddPostTag();
            promise.tagId = tagId;
            promise.id = postId;

            const request = client.patch(promise);

            return Observable.from(request);
        }
    },

    saveResourceTag: (tagId: number, resourceId: number) => {
        var client = new JsonServiceClient("");
        
        if (tagId && resourceId) {
            var promise = new CreDtos.AddResourceTag();
            promise.tagId = tagId;
            promise.id = resourceId;

            const request = client.patch(promise);

            return Observable.from(request);
        }
    },

    sortResourceItem: (forumId: number, resourceId: number, newIndex: number) => {
        var client = new JsonServiceClient("");

        var promise = new CreDtos.SortResourceItem();

        promise.forumId = forumId;
        promise.resourceId = resourceId;
        promise.newIndex = newIndex;

        const request = client.put(promise);

        return Observable.from(request);
    },

    followPost: (postId: number, subscribed: boolean) => {
        var client = new JsonServiceClient("");
        
        if (postId) {
            var promise = new CreDtos.FollowPost();
            promise.unfollow = subscribed;
            promise.postId = postId;

            const request = client.patch(promise);

            return Observable.from(request);
        }
    },

    setNotificationActive: (value: string) => {
        var client = new JsonServiceClient("");

        var promise = new CreDtos.UpdateNotificationSetting();
        promise.active = value == "1" || value == "true" ? true : false;

        const request = client.put(promise);

        return Observable.from(request);
    },

    setNotificationFrequency: (value: number) => {
        var client = new JsonServiceClient("");

        var promise = new CreDtos.UpdateEmailFrequencySetting();
        promise.value = value;

        const request = client.put(promise);

        return Observable.from(request);
    }
};




// WEBPACK FOOTER //
// ./src/services/forum.ts